import { render } from "./admin.vue?vue&type=template&id=7a08e633&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=7a08e633&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a08e633"]])

export default __exports__